import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HolderComponent } from './components/holder/holder.component';
import { LoginComponent } from './components/login/login.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { ProductManPreviewComponent } from './components/product-man-preview/product-man-preview.component';
import { ProductManSettingsComponent } from './components/product-man-settings/product-man-settings.component';
import { ProductManComponent } from './components/product-man/product-man.component';
import { TiketComponent } from './components/tiket/tiket.component';
import { UserManComponent } from './components/user-man/user-man.component';
import { LogInService } from './log-in.service';
import { PayTableInfoComponent } from './components/pay-table-info/pay-table-info.component';
import { CcyManagementComponent } from './components/ccy-management/ccy-management.component';
import { BlockedPlayersComponent } from './components/blocked-players/blocked-players.component';
import { TranslationsComponent } from './components/translations/translations.component';
import { ThemeComponent } from './components/theme/theme.component';
import { ProductManSettingsGuard } from './guards/product-man-settings.guard';
import { BetstopStatusComponent } from './components/betstop-status/betstop-status.component';

@Component({
    selector: 'app-empty',
    template: ''
})
export class EmptyComponent {}

const routes: Routes = [
    { path: '', component: LoginComponent },
    {
        path: 'home',
        canActivate: [LogInService],
        component: HolderComponent,
        children: [
            { path: '', component: EmptyComponent, pathMatch: 'full' },
            {
                path: 'product_man_preview/:gameCode/:clientUuid',
                component: ProductManPreviewComponent
            },
            {
                path: 'product_man_settings/:gameCode',
                component: ProductManSettingsComponent,
                canActivate: [ProductManSettingsGuard]
            },
            { path: 'user_man', component: UserManComponent },
            { path: 'tickets/:gameCode', component: TiketComponent },
            { path: 'password_reset', component: PasswordResetComponent },
            {
                path: 'pay_table_info/:gameCode',
                component: PayTableInfoComponent
            },

            // {path:'clients', component:ClientsComponent},
            // {path:'shops', component:ShopsComponent},
            { path: 'app-ccy-management', component: CcyManagementComponent },
            { path: 'app-blocked-players', component: BlockedPlayersComponent },
            { path: 'app-betstop-status', component: BetstopStatusComponent },
            { path: 'translations', component: TranslationsComponent },
            { path: 'theme', component: ThemeComponent }
            // {path:'groups', component:GroupsComponent},
        ]
    },
    { path: '**', redirectTo: '/home' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule],
    declarations: [EmptyComponent]
})
export class AppRoutingModule {}
